import * as THREE from 'three';

import {UPDATE_RADIUS} from '../actions/planet';

export default(state = {
    far: 310.656,
    fov: 60,
    near: 1,
    position: new THREE.Vector3(0, 0, 155.328)
}, action) => {
    switch (action.type) {
        case UPDATE_RADIUS:
            const radius = parseInt(action.radius, 10),
                distance = radius * 1.618 / Math.sin(state.fov * Math.PI / 180 / 2);
            return {
                ...state,
                far: distance * 2,
                position: new THREE.Vector3(0, 0, distance)
            }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/apps/scene-planet/reducers/camera.js